import graphql from "babel-plugin-relay/macro";

import {
  WhooshMutationError,
  useMutationWithError,
} from "../../../../../../../utils/hooks/useMutationWithError";
import {
  SetUserNotificationPreferencesLegacyInput,
  useSetUserNotificationPreferencesLegacyMutation,
} from "./__generated__/useSetUserNotificationPreferencesLegacyMutation.graphql";

export const useSetUserNotificationPreferencesLegacy = (
  callback: () => void,
  onError?: (errors: any) => void
) => {
  const [setUserNotificationPreferencesLegacy, isUpdating] =
    useMutationWithError<useSetUserNotificationPreferencesLegacyMutation>(
      UseSetUserNotificationPreferencesLegacyMutationString
    );

  const handleUserNotificationsPreferencesLegacy = (
    input: SetUserNotificationPreferencesLegacyInput
  ) => {
    setUserNotificationPreferencesLegacy({
      variables: { input },
      onCompleted: () => {
        callback();
      },
      onCompletedErrorCustom: (errors: WhooshMutationError[]) => {
        onError?.(errors);
        return errors;
      },
    });
  };
  return [handleUserNotificationsPreferencesLegacy, isUpdating] as const;
};

export const UseSetUserNotificationPreferencesLegacyMutationString = graphql`
  mutation useSetUserNotificationPreferencesLegacyMutation(
    $input: SetUserNotificationPreferencesLegacyInput!
  ) {
    responsePayload: setUserNotificationPreferencesLegacy(input: $input) {
      success
      errors {
        code

        message
        field
      }
    }
  }
`;
